// @flow
import store from 'store';

import { refreshedOAuthToken as refreshedOAuthTokenAction } from './actions';
import { REDUCER_KEY } from './reducer';
import type { AuthTokenData } from './types';

// ================================================================================================
// These are provided to use when redux is not available (e.g. AxiosFactory)
// ================================================================================================

export const getAuthSession = () => store.getState()[REDUCER_KEY];

export const dispatchRefreshedOAuthTokenAction = (authTokenData: AuthTokenData) =>
  store.dispatch(refreshedOAuthTokenAction(authTokenData));

